import { HelpTip } from './types';

export const VEHICLE_TIPS = {
  vehiclesTable: {
    title: { fr: 'Les véhicules', en: 'Vehicles' },
    text: {
      fr: "Liste des véhicules de votre périmètre. Chaque véhicule appartient à un groupe ou à une société et regroupe l'historique de ses inspections. Vous pouvez en ajouter un à la main ou importer une liste depuis un fichier.",
      en: 'List of the vehicles of your scope. Each vehicle belongs to a group or a company and keeps the history of its inspections. You can add one manually or import a list from a file.',
    },
    docSlug: 'liste-des-vehicules',
  },
  awaitingInspectionColumn: {
    title: { fr: "En attente d'inspection", en: 'Awaiting inspection' },
    text: {
      fr: "Indique que le véhicule doit être inspecté. Le changement est enregistré immédiatement. En sélectionnant des lignes, l'interrupteur de la barre d'actions permet de marquer (ou démarquer) tous les véhicules de la page, après confirmation. Le filtre « Véhicule en attente d'inspection » retrouve ces véhicules.",
      en: 'Flags the vehicle as having to be inspected. The change is saved immediately. When rows are selected, the switch of the actions bar flags (or unflags) all the vehicles of the page, after confirmation. The "Vehicle awaiting inspection" filter finds these vehicles.',
    },
    docSlug: 'liste-des-vehicules',
  },
  ownerColumn: {
    title: { fr: 'Propriétaire', en: 'Owner' },
    text: {
      fr: "Structure à laquelle appartient le véhicule : un groupe ou une société. Le propriétaire se modifie depuis la fiche du véhicule ; lors d'un changement, vous pouvez choisir de laisser une copie du véhicule à l'ancien propriétaire.",
      en: 'Structure owning the vehicle: a group or a company. The owner is changed from the vehicle sheet; when it changes, you can choose to leave a copy of the vehicle to the previous owner.',
    },
    docSlug: 'fiche-vehicule',
  },
  statusColumn: {
    title: { fr: 'État du véhicule', en: 'Vehicle status' },
    text: {
      fr: 'Un véhicule inactif apparaît grisé dans la liste. Depuis la liste, un véhicule qui possède déjà des inspections ne peut être ni désactivé ni supprimé. La suppression est réservée aux administrateurs et est définitive.',
      en: 'An inactive vehicle is greyed out in the list. From the list, a vehicle that already has inspections can neither be deactivated nor deleted. Deletion is reserved to administrators and is permanent.',
    },
    docSlug: 'fiche-vehicule',
  },
  inspectionsColumn: {
    title: { fr: 'Inspections réalisées', en: 'Completed inspections' },
    text: {
      fr: "Nombre d'inspections réalisées sur ce véhicule (les demandes pas encore réalisées ne sont pas comptées). La flèche ouvre l'onglet « Inspections » de la fiche du véhicule.",
      en: 'Number of inspections completed on this vehicle (requests not completed yet are not counted). The arrow opens the "Inspections" tab of the vehicle sheet.',
    },
    docSlug: 'liste-des-inspections',
  },
} satisfies Record<string, HelpTip>;
